import { render, staticRenderFns } from "./sph.vue?vue&type=template&id=12bd6dc8&scoped=true&"
import script from "./sph.vue?vue&type=script&lang=js&"
export * from "./sph.vue?vue&type=script&lang=js&"
import style0 from "./sph.vue?vue&type=style&index=0&id=12bd6dc8&lang=scss&scoped=true&"
import style1 from "./sph.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bd6dc8",
  null
  
)

export default component.exports